<template>
    <div id="etiquetas" class="d-flex justify-content-center align-items-center mt-2">
        <!-- ETIQUETA 1 -->
        <div class="d-flex flex-column m-1" v-if="escolha == 1">
            <div class="d-flex mb-3">
                <div class="etiquetas">
                    <div class="c-etiqueta rounded d-flex flex-column align-items-center justify-content-between p-2">
                        <div class="text-left w-100">
                            <h3 class="titulo m-0"><b>0000 - Nome do Produto</b></h3>
                        </div>
                        <div class="d-flex align-items-center h-100">
                            <div>
                                <p class="valor"><b>R$ 99,99</b></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <h6 class="mb-2"><b>Informações do Papel:</b></h6>
                    <p>Pimaco Cod.: A4256 ou A4 Comum</p>
                    <p>25,4mm x 63,5mm</p>
                    <p>33 Etiquetas Por Pagina</p>
                </div>
            </div>

            <div class="text-center">
                <p><b>Exemplo de Digitação por Linha:</b> 0000 - Nome do Produto;99,99</p>
            </div>
        </div>

        <!-- ETIQUETA 2 -->
        <div class="d-flex flex-column m-1" v-if="escolha == 2">
            <div class="d-flex mb-3">
                <div class="etiquetas">
                    <div class="c-etiqueta rounded d-flex flex-column align-items-center justify-content-between p-2">
                        <div class="text-left w-100">
                            <h3 class="titulo"><b>0000 - Nome do Produto</b></h3>
                        </div>
                        <div class="d-flex align-items-center h-100">
                            <div>
                                <div class="d-flex flex-column de-caixa text-center">
                                    <div class="corte"></div>
                                    <p class="de m-0"><b>DE: R$ 99,99</b></p>
                                </div>
                                <p class="por"><b>POR: R$ 49,99</b></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <h6 class="mb-2"><b>Informações do Papel:</b></h6>
                    <p>Pimaco Cod.: A4256 ou A4 Comum</p>
                    <p>25,4mm x 63,5mm</p>
                    <p>33 Etiquetas Por Pagina</p>
                </div>
            </div>

            <div>
                <p><b>Exemplo de Digitação por Linha:</b> 0000 - Nome do Produto;99,99;49,99</p>
            </div>
        </div>

        <!-- ETIQUETA 3 -->
        <div class="d-flex flex-column m-1" v-if="escolha == 3">
            <div class="d-flex mb-3">
                <div class="etiquetas">
                    <div class="c-etiqueta rounded d-flex flex-column align-items-center justify-content-between p-2">
                        <div class="text-left w-100">
                            <h3 class="titulo m-0"><b>0000 - Nome do Produto</b></h3>
                        </div>
                        <div class="d-flex align-items-center h-100">
                            <div>
                                <p class="valor"><b>R$ 99,99</b></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <h6 class="mb-2"><b>Informações do Papel:</b></h6>
                    <p>Pimaco Cod.: A4251, A4351 A4 ou A4 Comum</p>
                    <p>21,2mm x 38,2mm</p>
                    <p>65 Etiquetas Por Pagina</p>
                </div>
            </div>

            <div class="text-center">
                <p><b>Exemplo de Digitação por Linha:</b> 0000 - Nome do Produto;99,99</p>
            </div>
        </div>

        <!-- ETIQUETA 4 -->
        <div class="d-flex flex-column m-1" v-if="escolha == 4">
            <div class="d-flex mb-3">
                <div class="etiquetas">
                    <div class="c-etiqueta rounded d-flex flex-column align-items-center justify-content-between p-2">
                        <div class="text-left w-100">
                            <h3 class="titulo"><b>0000 - Nome do Produto</b></h3>
                        </div>
                        <div class="d-flex align-items-center h-100">
                            <div>
                                <div class="d-flex flex-column de-caixa text-center">
                                    <div class="corte"></div>
                                    <p class="de m-0"><b>DE: R$ 99,99</b></p>
                                </div>
                                <p class="por"><b>POR: R$ 49,99</b></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <h6 class="mb-2"><b>Informações do Papel:</b></h6>
                    <p>Pimaco Cod.: A4251, A4351 A4 ou A4 Comum</p>
                    <p>21,2mm x 38,2mm</p>
                    <p>65 Etiquetas Por Pagina</p>
                </div>
            </div>

            <div>
                <p><b>Exemplo de Digitação por Linha:</b> 0000 - Nome do Produto;99,99;49,99</p>
            </div>
        </div>
    </div>
</template>

<script>

export default{
    data(){
        return{

        }
    },

    props:{
        escolha: Number
    },
}
</script>
<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

    body{
        position: fixed;
    }

    p{
        margin: 0px;
        padding: 0px;
        font-family: 'Roboto', sans-serif;
    }

    h6{
        margin: 0px;
    }

    .titulo{
        font-size: 11px;
    }

    $component-name: 'c-etiqueta';
    .#{$component-name}{
        border: 1px solid black;
        width: 63.5mm;
        height: 25.4mm;
        margin: 0cm 0.15cm 0cm 0.15cm;

        .valor{
            font-size: 25px;
        }

        .de{
            font-size: 15px;
        }

        .de-caixa{
            position: relative;
        }

        .por{
            font-size: 20px;
        }

        .corte{
            position:absolute;
            top: 10px;
            left: 15px;
            background-color: rgb(0, 0, 0);
            width: 25mm;
            height: 0.20mm;
        }
    }

    .conteudo1{
        // margin-left: 6px;
        max-width: 70px;
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: left;

        .produto{
            padding-left: 2px;
            padding-right: 2px;
            font-size: 10px;
            line-height: 15px;
        }

        .codigo{
            font-size: 8px;
        }
    }
    .conteudo2{
        color: #59595B;
        display: flex;
        align-items: flex-end;
        .valor{
            font-size: 45px;
            .centavos{
                font-size: 12px;
            }

            .cifra{
                position: relative;
                font-size: 10px;
                top: -30px;
            }
        }
    }

    // CSS ETIQUETA 2

    $component-name: 'c-etiqueta2';
    .#{$component-name}{
        background-color: red;
        margin: 5px;
        width: 8.5cm;
        height: 4.5cm;
        min-width: 8.5cm;
        min-height: 4.5cm;
        position: relative;
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column;

        &__title{
            color: white;
            font-size: 25px;
        }
    }    
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/Etiquetas.vue